import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import AppointmentType from "./AppointmentType";
import Department from "./Department";
import Designation from "./Designation";
import HospitalUnit from "./HospitalUnit";
import OpdRoomNo from "./OpdRoomNo";
import IpdRoomNo from "./IpdRoomNo";


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ px: 3 }}>
          {/* <Typography> </Typography> */}
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function MasterHead_Tabs() {
  // export default function BasicTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs" variant="scrollable"  scrollButtons allowScrollButtonsMobile>
          <Tab label="Hospital-Unit" {...a11yProps(0)} />
          <Tab label="Appointment-Type" {...a11yProps(1)} />
          <Tab label="Department" {...a11yProps(2)} />
          <Tab label="Designation" {...a11yProps(3)} />
          <Tab label="Opd-Room-No" {...a11yProps(4)} />          
          <Tab label="Ipd-Room-No" {...a11yProps(5)} />          
          {/* <Tab label="Banned-Reason" {...a11yProps(6)} /> */}
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <HospitalUnit />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <AppointmentType />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Department />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <Designation />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <OpdRoomNo />
      </TabPanel>
      <TabPanel value={value} index={5}>
        <IpdRoomNo />
      </TabPanel>
     
      <TabPanel value={value} index={6}>
        {/* <OpdRoomNo /> */}
      </TabPanel>
    </Box>
  );
}
